import { memo, useEffect, useRef, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';

const frasesLoading = [
  'Analisando a carteira',
  'Verificando o limite do Sacado',
  'Verificando o limite do Cedente',
  'Verificando os fatores das operações',
  'Verificando o PMP da carteira',
  'Verificando o vencimento dos títulos',
  'Verificando lista de sacados',
  'Organizando os títulos para exibição',
  'Montando a simulação'
];

function LoadingBox({ passos = frasesLoading, passoMs = 650, iniciar = true, onFim }) {
  const [currentStep, setCurrentStep] = useState(0);
  const timerRef = useRef(null);
  const latestOnFim = useRef(onFim);
  latestOnFim.current = onFim;
  const latestPassos = useRef(passos);
  latestPassos.current = passos;

  useEffect(() => {
    if (!iniciar) {
      clearInterval(timerRef.current);
      timerRef.current = null;
      return;
    }

    if (timerRef.current) {
      return;
    }

    setCurrentStep(0);

    timerRef.current = setInterval(() => {
      setCurrentStep(prev => {
        const next = prev + 1;
        const passosAtuais = latestPassos.current;

        if (next > passosAtuais.length) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          return prev;
        }

        if (next === passosAtuais.length) {
          clearInterval(timerRef.current);
          timerRef.current = null;
          latestOnFim.current?.();
        }
        return next;
      });
    }, passoMs);

    return () => {
      clearInterval(timerRef.current);
      timerRef.current = null;
    };
  }, [iniciar, passoMs]);

  const finished = currentStep >= passos.length;
  const visibleCount = finished ? passos.length : currentStep + 1;

  return (
    <Box className="simulacao-content">
      {passos.slice(0, visibleCount).map((label, idx) => {
        const concluido = finished ? true : idx < currentStep;
        const ultimoElemento = idx === passos.length - 1;

        return (
          <Box className={`${ultimoElemento ? 'ultimo-elemento' : ''} simulacao-title`} key={label}>
            {concluido && <CheckBoxOutlinedIcon className="icone-check" fontSize="small" />}
            {!concluido && <CircularProgress size="18px" />}
            <Box className="simulacao-label">{label}</Box>
          </Box>
        );
      })}
    </Box>
  );
}

export default memo(LoadingBox);
